import { render, staticRenderFns } from "./RevenueBySchoolChart.vue?vue&type=template&id=64ad671a"
import script from "./RevenueBySchoolChart.vue?vue&type=script&lang=js"
export * from "./RevenueBySchoolChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports